export default __webpack_public_path__ + "static/media/Express.f2ca69e8.svg";